/* src/app/weighbridge/pages/weighbridge/weighbridge.component.scss */
/*# sourceMappingURL=weighbridge.component.css.map */
